(() => {
  const trackedFrames = new WeakSet();
  const frameIds = new Set(['chat-window', 'chat-button', 'chat-campaigns', 'chat-input']);
  const css = `
    html body, html body :is(button, input, textarea, select, p, a, span, div, label, h1, h2, h3, h4, h5, h6, li) {
      font-family: "futura-pt", Arial, Helvetica, sans-serif !important;
    }
    #homepage-header img[alt="CASCAS Support logo"] {
      visibility: hidden !important;
    }
    #mountHere > .frame-content > [role="dialog"][aria-labelledby="gorgias-chat-dialog-title"] {
      background: #eeeeee url("https://cdn.shopify.com/s/files/1/0703/9464/2696/files/cascas-chat-background-blindpraegung.png?v=1792253382") right bottom / cover no-repeat !important;
    }
    #self-service-portal-container div:has(> div > canvas),
    #conversation,
    #conversation div:has(> div > span > button[role="button"][aria-label^="Send "]) {
      background: transparent !important;
    }
    #self-service-portal-container canvas {
      display: none !important;
    }
  `;

  function styleFrame(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head) return;
      if (!doc.getElementById('cascas-gorgias-font')) {
        const link = doc.createElement('link');
        link.id = 'cascas-gorgias-font';
        link.rel = 'stylesheet';
        link.href = 'https://use.typekit.net/iiz7owd.css';
        doc.head.append(link);
      }
      if (!doc.getElementById('cascas-gorgias-brand')) {
        const style = doc.createElement('style');
        style.id = 'cascas-gorgias-brand';
        style.textContent = css;
        doc.head.append(style);
      }
    } catch (_) {}
  }

  function update() {
    const container = document.getElementById('gorgias-chat-container');
    if (!container) return;
    container.querySelectorAll('iframe').forEach(frame => {
      if (!frameIds.has(frame.id)) return;
      if (!trackedFrames.has(frame)) {
        trackedFrames.add(frame);
        frame.addEventListener('load', () => styleFrame(frame));
      }
      styleFrame(frame);
    });
  }

  const observer = new MutationObserver(update);
  observer.observe(document.documentElement, {childList: true, subtree: true});
  window.addEventListener('gorgias-widget-loaded', update);
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
  update();
})();

